<template>
  <div class="d-none d-lg-inline-block ml-11">
    <button type="button" class="btn header-item" @click="$router.push('/tickets/unassigned')">
      <i v-if="unassignedCount > 0" class="fas fa-exclamation-circle mr-1 text-danger"></i>
      {{ unassignedCount !== null ? unassignedCount : '-' }} Unassigned 
      {{ unassignedCount === 1 ? 'Ticket' : 'Tickets' }}
    </button>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "UnassignedTickets",

  data() {
    return {
      unassignedCount: null
    }
  },

  methods: {
    async authenticateEcho() {
      const token = await this.$auth.getTokenPopup();
      window.Echo.connector.options.auth.headers['Authorization'] = 'Bearer ' + token.access_token
      window.Echo.options.auth = {
        headers: {
          Authorization: 'Bearer ' + token,
        },
      };
    },

    getUnassignedCount() {
      axios.get(API_BASE + '/tickets/unassigned-count')
        .then(r => {
          this.unassignedCount = r.data.count;
        })
        .catch(e => {
          console.log(e);
          this.unassignedCount = null;
        });
    },

    setupTicketUpdatesListener() {
      window.Echo.channel('ticket-updates')
        .listen('AssignmentChanged', () => {
          this.getUnassignedCount();
        });
    }
  },

  async mounted() {
    await this.authenticateEcho();
    this.getUnassignedCount();
    this.setupTicketUpdatesListener();
  }
}
</script>

<style scoped>

</style>
